import { compose } from 'react-apollo'
import { graphql } from '@apollo/client/react/hoc';
import { gql } from '@apollo/client';

import AppRouter from './AppRouter'

export default compose(
  graphql(gql`query {
    data_json {
      json,
      user {
        id,
        phone,
        role_id
      },
      leads {
        id,
        act_number
      },
      drivers {
        id,
        name,
        phone
      }
    }
  }`, {
    options: {
      pollInterval: 40000
    },
  }),
)(AppRouter);